
import { createSelector } from "@reduxjs/toolkit";
import { StoreWithStrapi, StrapiItem } from "../types/types";

export const selectModelData = createSelector(
  [(state: any, modelName: string) => state.gop.gop[modelName]?.data],
  (data) => data || []
);

export const selectModelLoading = (state: StoreWithStrapi, modelName: string): boolean =>
  state.gop.gop[modelName]?.loading || false;

export const selectModelError = (state: StoreWithStrapi, modelName: string): string | null =>
  state.gop.gop[modelName]?.error || null;
//! id крайней созданной записи
export const selectLastAddedId = createSelector(
  [(state: any, modelName: string) => state.gop.gop[modelName]?.lastAddedId],
  (lastAddedId) => lastAddedId || null
);
//! Documentid крайней созданной записи
export const selectLastDocId = createSelector(
  [(state: any, modelName: string) => state.gop.gop[modelName]?.lastDocId],
  (lastDocId) => lastDocId || null
);

export const selectModelItemById = (state: StoreWithStrapi, modelName: string, id: number): StrapiItem | undefined =>
  selectModelData(state, modelName).find(item => item.id === id);

export const selectModelPagination = (state: any, modelName: string) => {
  return state.gop.gop[modelName]?.pagination || null;
};

export const selectCommentByContext = createSelector(
  [(state: any) => state.gop.gop.commentByContext?.data],
  (data) => data || []
);